import React, { Component } from "react";
import { graphql } from "gatsby";
import Layout from "../components/layout";
import Tile from "../components/tile";
import SEO from "../components/seo";

class Pricing extends Component {
  constructor(props) {
    super(props);
    this.removeUrl = this.removeUrl.bind(this);
  }

  removeUrl(url) {
    let arr = url.split("/");
    arr.splice(0, 3);
    return arr.join("/");
  }

  render() {
    return (
      <Layout location="pricing">
        <SEO title="Pricing" />
        <section className="section pricing-items">
          <div className="container">
            <div className="columns is-mobile is-multiline is-centered">
              <div className="column is-full">
                <h1>Pricing</h1>
              </div>
              {this.props.data.allWordpressPage.edges.map(({ node }) => (
                <Tile
                  key={node.title}
                  className="column is-full-mobile is-half-tablet is-one-third-desktop"
                  image={node.acf.thumbnail.localFile.childImageSharp.fluid}
                  title={node.title}
                  slug={`/${this.removeUrl(node.link)}`}
                />
              ))}
            </div>
          </div>
        </section>
      </Layout>
    );
  }
}

export default Pricing;

export const query = graphql`
  query PricingPageQuery {
    allWordpressPage(
      filter: { template: { eq: "page-pricing.php" } }
      sort: { fields: [menu_order], order: ASC }
    ) {
      edges {
        node {
          title
          link
          acf {
            thumbnail {
              localFile {
                childImageSharp {
                  fluid(maxWidth: 600) {
                    ...GatsbyImageSharpFluid_withWebp
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;
